'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactDom = require('react-dom');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _theme = require('HubStyleTokens/theme');

var _sizes = require('HubStyleTokens/sizes');

var _createChainablePropType = require('../utils/propTypes/createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

var _ComponentWithWindowListeners = require('../mixins/ComponentWithWindowListeners');

var _ComponentWithWindowListeners2 = _interopRequireDefault(_ComponentWithWindowListeners);

var _Functions = require('../core/Functions');

var _Overflows = require('../utils/Overflows');

var _UIList = require('../list/UIList');

var _UIList2 = _interopRequireDefault(_UIList);

var _UISection = require('../section/UISection');

var _UISection2 = _interopRequireDefault(_UISection);

var _UIDropdown = require('../dropdown/UIDropdown');

var _UIDropdown2 = _interopRequireDefault(_UIDropdown);

var _UIButton = require('../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _Styles = require('../utils/Styles');

var _tabUtils = require('./utils/tabUtils');

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _Timers = require('../utils/Timers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isTabComponent = function isTabComponent(child) {
  var propTypes = child && child.type && child.type.propTypes;
  return propTypes && propTypes.tabId && propTypes.title;
};

var isWhitespace = function isWhitespace(str) {
  return typeof str === 'string' && !str.match(/\S/);
};

var getActiveTabPanel = function getActiveTabPanel(selected, childArray) {
  for (var i = 0; i < childArray.length; i++) {
    var child = childArray[i];

    var _ref = child && child.props ? child.props : {},
        tabContent = _ref.children,
        tabId = _ref.tabId;

    if (tabId === selected) {
      return tabContent;
    }
  }
  return null;
};

// `PropTypes.children`, but checks all children are `UITab` nodes
var childrenPropTypeValidator = (0, _createChainablePropType2.default)(function (props, propName, componentName) {
  // Only accept UITab instances as children
  var valid = true;
  _react.Children.forEach(props[propName], function (child) {
    if (child != null && !isTabComponent(child) && !isWhitespace(child)) {
      valid = false;
    }
  });
  if (!valid) {
    return new Error(componentName + ': All children must be instances of UITab.');
  }
  return null;
}, 'node' // TODO: render "`UITab`s" instead, linked to the UITab docs
);

var StyledList = (0, _styledComponents2.default)(function (props) {
  var __bordered = props.bordered,
      __use = props.use,
      __fill = props.fill,
      rest = _objectWithoutProperties(props, ['bordered', 'use', 'fill']);

  return _react2.default.createElement('div', rest);
}).withConfig({
  displayName: 'UITabs__StyledList'
})(['display:', ';border-bottom:1px solid ', ';margin-bottom:-1px;', ';', ';', ';', ';', ';'], function (_ref2) {
  var use = _ref2.use;
  return (0, _tabUtils.isContained)(use) ? 'inline-flex' : 'flex';
}, function (_ref3) {
  var bordered = _ref3.bordered;
  return bordered ? _theme.TABS_BORDER_COLOR : 'transparent';
}, function (_ref4) {
  var use = _ref4.use;
  return use === 'header' ? (0, _styledComponents.css)(['padding-left:', ';'], _sizes.LAYOUT_PADDING_X) : null;
}, function (_ref5) {
  var fill = _ref5.fill;
  return fill ? (0, _styledComponents.css)(['width:100%;']) : null;
}, function (_ref6) {
  var use = _ref6.use;
  return use === 'enclosed' ? (0, _styledComponents.css)(['border:1px solid ', ';border-top-left-radius:', ';border-top-right-radius:', ';'], _theme.TABS_BORDER_COLOR, _sizes.BUTTON_RADIUS, _sizes.BUTTON_RADIUS) : null;
}, function (_ref7) {
  var use = _ref7.use;
  return use === 'flush' ? (0, _styledComponents.css)(['border-top:1px solid ', ';'], _theme.TABS_BORDER_COLOR) : null;
}, function (_ref8) {
  var use = _ref8.use,
      fill = _ref8.fill;
  return (use === 'flush' || use === 'toolbar') && !fill ? (0, _styledComponents.css)(['border-right:1px solid ', ';'], _theme.TABS_BORDER_COLOR) : null;
});
StyledList.displayName = 'UITabs__StyledUITabsList';

var TabsPanel = (0, _styledComponents2.default)(_UISection2.default).withConfig({
  displayName: 'UITabs__TabsPanel'
})(['padding:16px;border-top:1px solid ', ';'], function (_ref9) {
  var bordered = _ref9.bordered;
  return bordered ? _theme.TABS_BORDER_COLOR : 'transparent';
});

var StyledWrapper = (0, _styledComponents2.default)(function (props) {
  var __bordered = props.bordered,
      __use = props.use,
      rest = _objectWithoutProperties(props, ['bordered', 'use']);

  return _react2.default.createElement('div', rest);
}).withConfig({
  displayName: 'UITabs__StyledWrapper'
})(['', ';'], function (_ref10) {
  var use = _ref10.use;
  return (0, _tabUtils.isContained)(use) ? (0, _styledComponents.css)(['position:relative;&::before{border-top:1px solid ', ';bottom:-1px;content:\'\';left:0;position:absolute;width:100%;}'], function (_ref11) {
    var bordered = _ref11.bordered;
    return bordered ? _theme.TABS_BORDER_COLOR : 'transparent';
  }) : null;
});
StyledWrapper.displayName = 'UITabs__StyledUITabsWrapper';

var StyledUITabs = (0, _styledComponents2.default)(function (props) {
  var __use = props.use,
      __fill = props.fill,
      rest = _objectWithoutProperties(props, ['use', 'fill']);

  return _react2.default.createElement('div', rest);
}).withConfig({
  displayName: 'UITabs__StyledUITabs'
})(['max-width:100%;', ';'], function (_ref12) {
  var use = _ref12.use;
  return use === 'header' ? (0, _styledComponents.css)(['margin-bottom:40px;& > ', '{padding-left:', ';}'], TabsPanel, _sizes.LAYOUT_PADDING_X) : null;
});

var ExcessTabsDropdownButton = (0, _styledComponents2.default)(function (props) {
  var __parentUse = props.parentUse,
      rest = _objectWithoutProperties(props, ['parentUse']);

  return _react2.default.createElement(_UIButton2.default, rest);
}).withConfig({
  displayName: 'UITabs__ExcessTabsDropdownButton'
})(['&&&{', ';flex-shrink:0;', ';}'], (0, _Styles.setInputMetrics)(_sizes.TAB_PADDING_Y, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_Y, false), function (_ref13) {
  var use = _ref13.parentUse;
  return (0, _tabUtils.isContained)(use) ? (0, _styledComponents.css)(['border-left:1px solid ', ';border-radius:0;'], _theme.TABS_BORDER_COLOR) : null;
});

var renderExcessTabsDropdown = function renderExcessTabsDropdown(moreTabsRenderer, childArray, excessTabCount, use, handleTabClick, refCallback) {
  if (moreTabsRenderer == null) return null;

  var excessTabs = childArray.slice(childArray.length - excessTabCount);
  var excessTabListItems = excessTabs.map(function (child) {
    var _ref14 = child && child.props ? child.props : {},
        onClick = _ref14.onClick;

    return _react2.default.cloneElement(child, {
      className: 'private-tab--in-dropdown',
      onClick: (0, _Functions.memoizedSequence)(handleTabClick, onClick),
      active: false,
      children: null,
      role: 'button',
      tooltipPlacement: undefined
    });
  });

  var moreTabs = moreTabsRenderer({ tabs: excessTabListItems, use: use });

  return _react2.default.cloneElement(moreTabs, {
    ref: refCallback
  });
};

var UITabs = _react2.default.createClass({
  displayName: 'UITabs',

  mixins: [_reactAddonsPureRenderMixin2.default, _ComponentWithWindowListeners2.default],

  propTypes: {
    bordered: _react.PropTypes.bool.isRequired,
    children: childrenPropTypeValidator,
    fill: _react.PropTypes.bool,
    List: _component2.default,
    listClassName: _react.PropTypes.string,
    moreTabsRenderer: _react.PropTypes.func,
    onSelectedChange: _react.PropTypes.func.isRequired,
    panelClassName: _react.PropTypes.string,
    selected: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
    use: _react.PropTypes.oneOf(_tabUtils.USES),
    Wrapper: _component2.default,
    wrapperClassName: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bordered: true,
      fill: false,
      moreTabsRenderer: function moreTabsRenderer(_ref15) {
        var tabs = _ref15.tabs,
            use = _ref15.use;
        return _react2.default.createElement(
          _UIDropdown2.default,
          {
            Button: ExcessTabsDropdownButton,
            'aria-hidden': true,
            buttonClassName: (0, _classNames2.default)('private-tabs__excess-tabs-dropdown', {
              hidden: tabs.length === 0
            }),
            buttonText: _I18n2.default.text('salesUI.UITabs.moreDropdownLabel'),
            buttonUse: 'transparent',
            'data-dropdown-tabs': tabs.length,
            placement: 'bottom left',
            responsive: false,
            tabIndex: -1,
            parentUse: use
          },
          _react2.default.createElement(
            _UIList2.default,
            null,
            tabs
          )
        );
      },
      List: StyledList,
      Wrapper: StyledWrapper
    };
  },
  getInitialState: function getInitialState() {
    return {
      excessTabCount: 0
    };
  },
  componentDidMount: function componentDidMount() {
    this.delayedFitToWidth();
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (prevState.excessTabCount === this.state.excessTabCount) {
      // All updates should trigger fitToWidth(), except updates that were
      // *caused* by fitToWidth()!
      this.delayedFitToWidth();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    (0, _Timers.cancelSchedulerCallback)(this._timeout);
  },
  getWindowListeners: function getWindowListeners() {
    return {
      resize: this.handleWindowResize
    };
  },
  handleWindowResize: function handleWindowResize() {
    this.delayedFitToWidth();
  },
  delayedFitToWidth: function delayedFitToWidth() {
    (0, _Timers.cancelSchedulerCallback)(this._timeout); // Ensure only one callback is queued at a time
    this._timeout = (0, _Timers.requestSchedulerCallback)(this.fitToWidth);
  },
  fitToWidth: function fitToWidth() {
    var moreTabsRenderer = this.props.moreTabsRenderer;

    if (moreTabsRenderer == null) {
      this.setState({ excessTabCount: 0 });
      return;
    }

    // Make sure we have a real container to work with
    var containerEl = this._containerEl;
    if (!containerEl || !document.body || !document.body.contains(containerEl)) {
      return;
    }

    // overflow: "visible" can cause clientWidth/scrollWidth to be miscalculated,
    // so we reset it to hidden until our computations are complete.
    var computedStyle = window.getComputedStyle(containerEl, null);
    if (computedStyle == null) return; // #4979
    var overflowVisible = computedStyle.overflow === 'visible';
    if (overflowVisible) {
      containerEl.classList.add('private-hide-overflow');
    }

    var newExcessTabCount = this.computeExcessTabCount(containerEl);

    // Reset the original element state
    if (overflowVisible) {
      containerEl.classList.remove('private-hide-overflow');
    }

    if (this.state.excessTabCount !== newExcessTabCount) {
      this.setState({ excessTabCount: newExcessTabCount });
    }
  },
  computeExcessTabCount: function computeExcessTabCount(containerEl) {
    var excessTabsDropdownEl = (0, _reactDom.findDOMNode)(this._moreTabs);
    var tabEls = containerEl.querySelectorAll('.private-tab');
    var visibleTabs = tabEls.length;
    var i = void 0;

    // Let's start by hiding the dropdown control and showing all tabs.
    excessTabsDropdownEl.classList.add('hidden');
    for (i = tabEls.length - 1; i >= 0; i--) {
      var classList = tabEls[i].classList;
      if (classList.contains('sr-only')) {
        classList.remove('sr-only');
        classList.remove('sr-only-focusable');
        classList.add('private-tabs-sr-only-placeholder');
      }
    }

    if ((0, _Overflows.overflowsX)(containerEl)) {
      // Uh-oh, everything doesn't fit. Let's show that dropdown control, then
      // hide tabs (from right to left) until that changes.
      excessTabsDropdownEl.classList.remove('hidden');
      for (visibleTabs = tabEls.length - 1; visibleTabs >= 1; visibleTabs--) {
        tabEls[visibleTabs].style.display = 'none';
        if (!(0, _Overflows.overflowsX)(containerEl)) {
          break;
        }
      }

      // Restore all of the tabs we hid during the previous loop
      for (i = tabEls.length - 1; i >= visibleTabs; i--) {
        tabEls[i].style.display = '';
      }
    }

    // Restore all of the sr-only classes that we removed earlier.
    for (i = tabEls.length - 1; i >= 0; i--) {
      var _classList = tabEls[i].classList;
      if (_classList.contains('private-tabs-sr-only-placeholder')) {
        _classList.remove('private-tabs-sr-only-placeholder');
        _classList.add('sr-only');
        _classList.add('sr-only-focusable');
      }
    }

    // Show or hide the excess tabs dropdown as appropriate (don't rely on render reconciliation).
    excessTabsDropdownEl.classList[visibleTabs === tabEls.length ? 'add' : 'remove']('hidden');

    return tabEls.length - visibleTabs;
  },
  handleTabClick: function handleTabClick(evt) {
    this.props.onSelectedChange(evt);
  },
  containerRefCallback: function containerRefCallback(ref) {
    this._containerEl = (0, _reactDom.findDOMNode)(ref);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        bordered = _props.bordered,
        children = _props.children,
        className = _props.className,
        fill = _props.fill,
        listClassName = _props.listClassName,
        moreTabsRenderer = _props.moreTabsRenderer,
        __onSelectedChange = _props.onSelectedChange,
        panelClassName = _props.panelClassName,
        selected = _props.selected,
        List = _props.List,
        use = _props.use,
        Wrapper = _props.Wrapper,
        wrapperClassName = _props.wrapperClassName,
        rest = _objectWithoutProperties(_props, ['bordered', 'children', 'className', 'fill', 'listClassName', 'moreTabsRenderer', 'onSelectedChange', 'panelClassName', 'selected', 'List', 'use', 'Wrapper', 'wrapperClassName']);

    var excessTabCount = this.state.excessTabCount;


    var childArray = _react.Children.toArray(children).filter(function (child) {
      return child && child.type;
    });
    var classes = (0, _classNames2.default)(className, 'private-tabs', {
      'private-tabs--enclosed': use === 'enclosed',
      'private-tabs--header': use === 'header',
      'private-tabs--flush': use === 'flush',
      'private-tabs--toolbar': use === 'toolbar'
    });

    // If the selected tab would be in the excess tab dropdown, move it to
    // first position instead.
    if (excessTabCount > 0) {
      for (var i = childArray.length - excessTabCount; i < childArray.length; i++) {
        if (childArray[i] && childArray[i].props.tabId === selected) {
          var firstChild = childArray[0];
          childArray[0] = childArray[i];
          childArray[i] = firstChild;
          break;
        }
      }
    }

    var activeTabPanel = getActiveTabPanel(selected, childArray);

    var componentRole = activeTabPanel ? 'tablist' : 'navigation';

    var excessTabsDropdown = renderExcessTabsDropdown(moreTabsRenderer, childArray, excessTabCount, use, this.handleTabClick, function (ref) {
      _this._moreTabs = ref;
    });

    var tabs = childArray.map(function (child, i) {
      var _ref16 = child && child.props ? child.props : {},
          active = _ref16.active,
          childClassName = _ref16.className,
          tabId = _ref16.tabId,
          onClick = _ref16.onClick;

      var hidden = i >= childArray.length - excessTabCount;
      var tabRole = activeTabPanel ? 'tab' : 'button';

      return _react2.default.cloneElement(child, {
        onClick: (0, _Functions.memoizedSequence)(_this.handleTabClick, onClick),
        active: active != null ? active : tabId === selected,
        'aria-current': !activeTabPanel && tabId === selected ? 'page' : null,
        'aria-selected': activeTabPanel && tabId === selected ? true : null,
        children: null,
        className: (0, _classNames2.default)(childClassName, {
          'sr-only': hidden,
          'sr-only-focusable': hidden
        }),
        role: tabRole,
        use: use,
        fill: fill
      });
    });

    return _react2.default.createElement(
      StyledUITabs,
      _extends({ className: classes, use: use, fill: fill }, rest),
      _react2.default.createElement(
        Wrapper,
        {
          bordered: bordered,
          className: (0, _classNames2.default)('private-tabs__list__wrapper', wrapperClassName),
          ref: this.containerRefCallback,
          use: use
        },
        _react2.default.createElement(
          List,
          {
            bordered: bordered,
            className: (0, _classNames2.default)('private-tabs__list', listClassName, {
              'private-tabs__list--enclosed': use === 'enclosed',
              'private-tabs__list--header': use === 'header',
              'private-tabs__list--fill': fill,
              'private-tabs__list--flush': use === 'flush',
              'private-tabs__list--toolbar': use === 'toolbar'
            }),
            role: componentRole,
            use: use,
            fill: fill
          },
          tabs,
          excessTabsDropdown
        )
      ),
      activeTabPanel ? _react2.default.createElement(
        TabsPanel,
        {
          bordered: bordered,
          className: (0, _classNames2.default)(panelClassName, 'private-tabs__panel'),
          role: 'tabpanel'
        },
        activeTabPanel
      ) : null
    );
  }
});

exports.default = (0, _Controllable2.default)(UITabs, ['selected']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/nav/UITabs.js
// module id = 657
// module chunks = 3 4